<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-11">
          <h1 class="title green">{{ title }}</h1>
        </div>
        <div class="column has-text-right">
          <button
            v-if="id != 0 && id != -1 && id != null"
            type="button"
            class="button is-danger"
            @click="deleteOccurence(id)"
          >
            <b-icon icon="delete-outline" />
          </button>

          <button type="button" class="button is-primary" @click="validateBeforeSubmit">
            <b-icon icon="content-save-outline" />
          </button>
        </div>
      </div>
      <hr />

      <b-field v-if="id !== -1" horizontal :label="$translate('id_shape') | capitalize">
        <b-input v-if="id !== -1" v-model="id" name="id_shape" disabled="true" />
      </b-field>
      <b-field
        horizontal
        :label="$translate('CUI') | capitalize"
        :message="errors.first('CUI')"
        :type="{ 'is-danger': errors.has('CUI') }"
      >
        <b-input v-model="shape.CUI" v-validate="'required|unique'" name="CUI" />
      </b-field>
      <b-field
        horizontal
        :label="$translate('commercial_name') | capitalize"
        :message="errors.first('commercial_name')"
        :type="{ 'is-danger': errors.has('commercial_name') }"
      >
        <b-input v-model="shape.commercial_name" v-validate="'required'" name="commercial_name" />
      </b-field>
      <b-field
        horizontal
        :label="$translate('fit_code') | capitalize"
        :message="errors.first('fit_code')"
        :type="{ 'is-danger': errors.has('fit_code') }"
      >
        <b-input v-validate="'required'" v-model="shape.fit_code" name="fit_code" />
      </b-field>

      <b-field
        horizontal
        :label="$translate('shapeType') | capitalize"
        :type="{ 'is-danger': errors.has('shapeType') }"
        :message="errors.first('shapeType')"
      >
        <b-select v-model="shapeType" @input="resetTable" v-validate="'required'" name="shapeType">
          <option disabled :value="''">{{ $translate('select_type') }}</option>
          <option v-for="option in $availableShoeType" :key="option" :value="option"
            >{{ $translate('shape_' + option) }}
          </option>
        </b-select>
      </b-field>

      <b-field
        v-if="$moduleConfiguration[module].shapesByGender"
        :type="{ 'is-danger': errors.has('catalogType') }"
        :message="errors.first('catalogType')"
        horizontal
        :label="$translate('catalogType') | capitalize"
      >
        <b-select multiple name="catalogType" v-model="shape.catalogType" v-validate="'required'">
          <option v-for="optio in $availableSexType" :key="optio" :value="optio">
            {{ $translate(optio) | capitalize }}
          </option>
        </b-select>
      </b-field>

      <hr class="green" />

      <b-field v-for="(size, index) in shape.sizes" :key="index" horizontal>
        <ShapeSize
          ref="ShapeSize"
          :module="module"
          :size="size"
          :index="index"
          :type="shape.type"
          @delete-row="deleteSize"
        />
      </b-field>

      <b-field horizontal>
        <b-button type="is-primary" icon-left="plus" @click="addSize">
          {{ $translate('add_size') | capitalize }}
        </b-button>
      </b-field>
      <b-field horizontal :message="errors.first('upload_input')" :type="{ 'is-danger': errors.has('upload_input') }">
        <label for="upload-input">
          <a class="button is-primary">
            <b-icon icon="upload" />
            <span>{{ $translate('upload_excel_button') }}</span>
          </a>
        </label>
        <input name="upload_input" v-validate="'ext:xlsx'" id="upload-input" type="file" @change="onChange" />
        <xlsx-read :file="file" @parsed="validateExcel">
          <xlsx-json v-if="isExcelValid" :options="{ header: tableHeaders }" @parsed="loadSizeTable"></xlsx-json>
        </xlsx-read>
      </b-field>
    </div>
    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false" />
  </section>
</template>

<script>
import { XlsxRead, XlsxJson } from 'vue-xlsx'
import * as XLSX from 'xlsx'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import ShapeSize from '@/views/Shapes/components/ShapeSize.vue'
//import { storage } from 'firebase';

export default {
  name: 'ShapeForm',
  components: { ShapeSize, XlsxJson, XlsxRead },
  $_veeValidate: {
    validator: 'new',
  },
  props: ['module'],
  mixins: [permissionMixin],
  data() {
    return {
      file: null,
      id: 0,
      title: '',
      uploadValue: 0,
      isSaveDisabled: false,
      isExcelValid: false,
      shape: {
        CUI: '',
        commercial_name: '',
        fit_code: '',
        sizes: [],
        type: '',
        catalogType: [],
      },
    }
  },
  computed: {
    shapeType: {
      get() {
        return this.shape.type
      },
      set(value) {
        this.isExcelValid = false
        this.shape.type = value
      },
    },
    tableHeaders() {
      // as below. table is universal as fits module is the best example we keep fits and then hide not useful headers
      return this.shape.type === 'high' ? this.$shapeTableHeadersHigh['fits'] : this.$shapeTableHeadersLow['fits']
    },
  },
  created() {
    this.id = this.$route.params.id
  },

  mounted() {
    let isAllowed = false
    switch (this.userInfo.type) {
      case 'A':
        isAllowed = true
        break
      case 'I':
        if (this.userInfo.level === 'S' || this.userInfo.level === '2') isAllowed = true
        break
    }
    if (!isAllowed) this.$router.push('/forbidden')
    if (this.$route.params.id === undefined && !this.$route.params.idtocopy) {
      this.$router.push('/forbidden')
    }

    this.title = this.id === -1 ? this.$translate('new_shape') : this.$translate('modify_shape')

    if (this.id !== -1 && this.$route.params.idtocopy === undefined) {
      this.loadDataToEdit()
    } else {
      if (this.$route.params.idtocopy !== undefined) {
        this.loadDataToCopy()
      }
    }

    this.$validator.extend('unique', async value => {
      let counter = 0
      await this.$db
        .collection(this.$moduleConfiguration[this.module].shapes)
        .where('CUI', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id !== this.id) {
              counter++
            }
          })
        })

      return counter <= 0
    })
  },
  methods: {
    validateExcel(data) {
      this.isExcelValid = false

      this.$validator.validate('shapeType').then(result => {
        if (result) {
          const totalColumn = this.countNotEmptyColumns(data)
          // the shape table to import is universal and not dipendant from module. Hidden fields for modular or eventually others
          const maxColumns =
            this.shape.type === 'high'
              ? this.$shapeTableHeadersHigh['fits'].length
              : this.$shapeTableHeadersLow['fits'].length
          if (totalColumn !== maxColumns) {
            this.isExcelValid = false
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('wrong_table'),
              type: 'is-danger',
            })
          } else {
            this.isExcelValid = true
          }
        }
      })
    },
    countNotEmptyColumns(data) {
      const firstSheetName = data.SheetNames[0]
      const worksheet = data.Sheets[firstSheetName]
      if (!worksheet || !worksheet['!ref']) return 0
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      let nonEmptyColumnCount = 0

      for (let col = range.s.c; col <= range.e.c; col++) {
        let isColumnEmpty = true

        for (let row = range.s.r; row <= range.e.r; row++) {
          const cellAddress = { c: col, r: row }
          const cellRef = XLSX.utils.encode_cell(cellAddress)
          const cell = worksheet[cellRef]

          if (cell && cell.v !== undefined && cell.v !== null && cell.v !== '') {
            isColumnEmpty = false
            break // Non serve controllare altre celle in questa colonna
          }
        }

        // Conta la colonna solo se non è vuota
        if (!isColumnEmpty) {
          nonEmptyColumnCount++
        }
      }

      return nonEmptyColumnCount
    },
    resetTable() {
      document.getElementById('upload-input').value = ''
      this.shape.sizes = []
    },
    loadSizeTable(sizes) {
      this.$validator.validate('shapeType').then(result => {
        if (result) {
          this.shape.sizes = []
          this.shape.sizes = sizes.slice(2)
        }
        this.isExcelValid = false
      })
    },
    onChange(event) {
      this.shape.sizes = []
      this.$validator.validate('upload_input').then(result => {
        if (result) {
          this.file = event.target.files ? event.target.files[0] : null
        }
      })
    },

    addSize() {
      this.shape.sizes.push({
        size: null,
        ball: null,
        instep: null,
        instep_italian: null,
        end_tomaia: null,
        heel: null,
        tomaia: null,
        length: null,
        width: null,
        toe_height: null,
      })
    },

    deleteSize(index) {
      this.shape.sizes = this.shape.sizes.filter((size, i) => i !== index)
    },

    validateBeforeSubmit() {
      const generalValidation = this.$validator.validateAll()
      const sizesValidation = this.$refs.ShapeSize ? this.$refs.ShapeSize.map(ref => ref.validateBeforeSubmit()) : []
      Promise.all([generalValidation, ...sizesValidation]).then(values => {
        if (values.every(result => result === true) && this.shape.sizes && this.shape.sizes.length) {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
          this.send()
          return
        }
        this.$buefy.notification.open({
          duration: 3000,
          message: !this.shape.sizes.length ? this.$translate('no_size_table') : this.$translate('failed_form'),
          type: 'is-danger',
        })
      })
    },

    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('shape_message_destroy'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('shape_message_confirm'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection(this.$moduleConfiguration[this.module].shapes)
            .doc(idtoerase)
            .delete()
            .then(async () => {
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
              await this.$router.push({ name: 'shapes', params: { module: this.module } })
            }),
      })
    },

    async send() {
      this.isSaveDisabled = true
      if (this.id === -1 || this.$route.params.idtocopy) {
        this.shape.registeredAt = new Date().getTime()
        let shapeRef = await this.$db.collection(this.$moduleConfiguration[this.module].shapes).add(this.shape)
        this.id = shapeRef.id
      }
      //console.log(this.shape)
      await this.$db
        .collection(this.$moduleConfiguration[this.module].shapes)
        .doc(this.id)
        .update(this.shape)
        .catch(() => {
          //err => {
          //console.log(err);
          this.isLoading = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
      this.isSaveDisabled = false
      await this.$router.push({ name: 'shapes', params: { module: this.module } })
    },

    loadDataToEdit() {
      this.$db
        .collection(this.$moduleConfiguration[this.module].shapes)
        .doc(this.id)
        .get()
        .then(doc => {
          this.shape = doc.data()
        })
    },
    loadDataToCopy() {
      this.$db
        .collection(this.$moduleConfiguration[this.module].shapes)
        .doc(this.$route.params.idtocopy)
        .get()
        .then(doc => {
          this.shape = doc.data()
        })
    },
  },
}
</script>
<style>
#upload-input {
  display: none;
}
</style>
